<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <h4>下列何者無法聯繫到客戶</h4>
          <div class="row">
            <div class="col-6">
              <div class="checkbox">
                <input type="checkbox" name="" id="checkbox-1" v-model="iaaCheck" value='mobile1' @click="clickAll = false">
                <label for="checkbox-1" class="fix-margin">手機1：{{custInfo.mobile01}}</label>
              </div>
            </div>
            <div class="col-6">
              <div class="checkbox">
                <input type="checkbox" name="" id="checkbox-2" v-model="iaaCheck" value='mobile2' @click="clickAll = false">
                <label for="checkbox-2" class="fix-margin">手機2：{{custInfo.mobile02}}</label>
              </div>
            </div>
            <div class="col-6">
              <div class="checkbox">
                <input type="checkbox" name="" id="checkbox-3" v-model="iaaCheck" value='phone' @click="clickAll = false">
                <label for="checkbox-3" class="fix-margin">電話：{{custInfo.tel_newest_area}} - {{custInfo.tel_newest}}</label>
              </div>
            </div>
            <div class="col-6">
              <div class="checkbox">
                <input type="checkbox" name="" id="checkbox-4" v-model="iaaCheck" value='address' @click="clickAll = false">
                <label for="checkbox-4" class="fix-margin">地址：{{custInfo.addr_newest_postal_cd}}{{custInfo.addr_newest_city_nm}}{{custInfo.addr_newest_line_1}}{{custInfo.addr_newest_line_2}} </label>
              </div>
            </div>
            <div class="col-6">
              <div class="checkbox">
                <input type="checkbox" name="" id="checkbox-5" v-model="iaaCheck" value='email' @click="clickAll = false">
                <label for="checkbox-5" class="fix-margin">Email：{{custInfo.email}}</label>
              </div>
            </div>
            <div class="col-6">
              <div class="checkbox">
                <input type="checkbox" name="" id="checkbox-6" v-model="iaaCheckall" @click="clickAll = true">
                <label for="checkbox-6" class="fix-margin">以上皆是</label>
              </div>
            </div>
          </div>
          <div class="action text-right">
            <a @click="cancelIAA()" class="btn btn-default">
              取消
            </a>
            <a @click="sendIAA()" class="btn btn-primary">
              確定
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addIAA_API } from '../../service';
import { updateIAA_API } from '../../service';

export default {
  name: 'IaaCheckModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    hasData:{
      type: Boolean,
      default: false
    },
    custInfo:{
      type: Object,
      default: () => ({
        party_id: '', 
        mobile01: '', 
        mobile02: '', 
        tel_newest_area: '', 
        tel_newest: '', 
        tel_newest_ext: '', 
        addr_newest_postal_cd: '', 
        addr_newest_city_nm: '', 
        addr_newest_line_1: '', 
        addr_newest_line_2: '', 
        email: ''
      })
    },
    queryData:{
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      iaaCheck: [],
      iaaCheckall: false,
      clickAll: false,
    }
  },
  mounted () {
  },
  watch: {
    open: 'selectOption',
    iaaCheckall (val) {
      if(this.clickAll){
        if(val){
          this.iaaCheck = ['phone', 'mobile1', 'mobile2', 'address', 'email']
        }else{
          this.iaaCheck = []
        }
      }
    },
    iaaCheck() {
      if(!this.clickAll){
        if(this.iaaCheck.length == 5){
          this.iaaCheckall = true
        }else{
          this.iaaCheckall = false
        }
      }
    }
  },
  methods: {
    sendIAA () {
      //this.$emit('submit', this.iaaCheck)
      var check_item = {
        tel: this.iaaCheck.indexOf("phone") != -1? 1: 0,
        mobile1: this.iaaCheck.indexOf("mobile1") != -1? 1: 0 ,
        mobile2: this.iaaCheck.indexOf("mobile2") != -1? 1: 0 ,
        addr: this.iaaCheck.indexOf("address") != -1? 1: 0,
        email: this.iaaCheck.indexOf("email") != -1? 1: 0
      } 
      // if(this.iaaCheck.indexOf("all") == 0) {
      //   check_item = {
      //       tel: 1,
      //       mobile1: 1 ,
      //       mobile2: 1 ,
      //       addr: 1,
      //       email: 1
      //     } 
      // } else {
      //   check_item = {
      //       tel: this.iaaCheck.indexOf("phone") != -1? 1: 0,
      //       mobile1: this.iaaCheck.indexOf("mobile1") != -1? 1: 0 ,
      //       mobile2: this.iaaCheck.indexOf("mobile2") != -1? 1: 0 ,
      //       addr: this.iaaCheck.indexOf("address") != -1? 1: 0,
      //       email: this.iaaCheck.indexOf("email") != -1? 1: 0
      //     } 
      // }
      let isSuccess = false
      if(this.hasData) {
        updateIAA_API(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, 0, check_item, 'update').then(result =>{
            if(result.header.status && result.header.status == "200") {
              isSuccess = true
            }
            this.$emit('submit', isSuccess)
          })
      } else {
        addIAA_API(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, 0, check_item, 'add').then(result =>{
            if(result.header.status && result.header.status == "200") {
              isSuccess = true
            }
            this.$emit('submit', isSuccess)
          })
      }
      
      //this.$emit('close')
    }, 
    cancelIAA () {

      this.$emit('close')
    }, 
    selectOption (){
      this.iaaCheck = this.queryData
    }

  } 
}
</script>

<style lang="scss" scoped>

.checkbox label.fix-margin {
  height: inherit !important;
  word-break: break-all;
}

.checkbox label.fix-margin:before {
  margin: 10px auto auto auto;
}

</style>
